import assets from "../../../assets/assets";
import axios from "../../../axios";
import React, { useState } from "react";
// import "./editDelete.css";

const DeleteComme = ({ setDelet,
  post_id,
  user_id,
  setIsInProgress,
  setIsCommented,
  isInProgress,
  commentData,
  isCommented,
  setFilter,
  filter,
  setComments,
  setCurrentCommentNumber,
  currentCommentNumber, }) => {
  const DeleteComment = async () => {
    setIsInProgress(!isInProgress);
    try {
      let res = await axios.delete(
        `/community/post/${post_id}/comment/delete/${commentData?.id}`,
        {
          data: { user_id },
        }
      );

      res && setIsCommented(!isCommented);
      setFilter({ ...filter, page: 1 });
      setComments([]);
      setIsInProgress(!isInProgress);
      setCurrentCommentNumber(currentCommentNumber - 1);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className=" delete_reply_transprant_body ">

        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_reply_container shadow relative ">
          <img
            src={assets.CrossIcon}
            className="w-7"
            style={{ position: "absolute", top: "3px", right: "3px" }}
            alt=""
            onClick={(e) => setDelet(false)}
          />
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            {/* <img
              src="/images/Dustbin.svg"
              alt="delete icon"
              className="delet_reply_icon"
            /> */}

            <span className="mt-4 mb-5 delete_reply_text">
              Are you sure you want to delete this Comment?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                disabled={isInProgress}
                className="btn btn-danger col-sm-5  reply_delete_btn"
                onClick={DeleteComment}
              >
                Yes
              </button>
              <button
                disabled={isInProgress}
                className="btn btn-danger col-sm-5 reply_delete_btn no"
                autoFocus
                onClick={(e) => setDelet(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteComme;
